module.exports = __webpack_public_path__ + "img/ico-plan.25b0d2a3.svg";